module.exports = __webpack_public_path__ + "static/010-7cc7b5942a4bed3128a9d3beed4d05cc.jpg";